import React from 'react'
import { Route } from 'react-router-dom'

import App from './components/App'
import MainPage from './components/MainPage'

export default (
  <div>
    <Route path="/" component={App} />
    <Route exact path="/" component={MainPage} />
  </div>
)



// WEBPACK FOOTER //
// src/routes.js